import { Injectable } from '@angular/core';

export interface DomainConfig {
  domain: string;
  loginRoute: string;
  defaultRoute: string;
  roleId?: string;
  loginLogo?: string;
  dashboardLogo?: string;
  dashboardLogoIcon?: string;
  favicon?: string;
  title?: string;
  buttonBgColor?: string;
  buttonTextColor?: string;
  buttonDisabledBgColor?: string;
  buttonDisabledTextColor?: string;
  companyName?: string;
  tenantId: string;
}

@Injectable({
  providedIn: 'root'
})
export class DomainConfigService {
  private domainConfigs: DomainConfig[] = [
    {
      domain: 'localhost', // For development
      loginRoute: '/login',
      defaultRoute: '/dashboard/all-application',
      loginLogo: './assets/images/logo.svg',
      dashboardLogo: './assets/images/logo.svg',
      dashboardLogoIcon: './assets/images/logo-icon.svg',
      favicon: './assets/images/favicon_crizac.png',
      title: 'Crizac Admin Dashboard',
      buttonBgColor: '#FF6525',
      buttonTextColor: '#ffffff',
      buttonDisabledBgColor: 'rgba(26, 27, 31, 0.12)',
      buttonDisabledTextColor: 'rgba(26, 27, 31, 0.38)',
      companyName: 'Crizac Ltd',
      tenantId:'1'
    }, // Default config (fallback) https://console-new.crizac.com/
    {
      domain: 'default', // https://console-new.crizac.com/
      loginRoute: '/login',
      defaultRoute: '/dashboard/all-application',
      loginLogo: './assets/images/logo.svg',
      dashboardLogo: './assets/images/logo.svg',
      dashboardLogoIcon: './assets/images/logo-icon.svg',
      favicon: './assets/images/favicon_crizac.png',
      title: 'Crizac Admin Dashboard',
      buttonBgColor: '#FF6525',
      buttonTextColor: '#ffffff',
      buttonDisabledBgColor: 'rgba(26, 27, 31, 0.12)',
      buttonDisabledTextColor: 'rgba(26, 27, 31, 0.38)',
      companyName: 'Crizac Ltd',
      tenantId:'1'
    },
    {
      domain: 'console.studiesplanet.com',
      // domain: 'localhost',
      loginRoute: '/login',
      defaultRoute: '/dashboard/all-application',
      roleId: '160',
      loginLogo: './assets/images/studies-planet.png',
      dashboardLogo: './assets/images/studies-planet_crizac_1.png',
      dashboardLogoIcon: './assets/images/studies-planet.png',
      favicon: './assets/images/studies-planet.png',
      title: 'Studies Planet Admin Dashboard',
      buttonBgColor: '#1e7f43',
      buttonTextColor: '#ffffff',
      buttonDisabledBgColor: 'rgba(26, 27, 31, 0.12)',
      buttonDisabledTextColor: 'rgba(26, 27, 31, 0.38)',
      companyName: 'Studies Planet',
      tenantId:'7'
    },
    {
      domain: 'console.globaltree.in',
      // domain: 'localhost',
      loginRoute: '/login',
      defaultRoute: '/dashboard/all-application',
      roleId: '156',
      loginLogo: './assets/images/global-tree_favicon.png',
      dashboardLogo: './assets/images/global-tree_crizac.png',
      dashboardLogoIcon: './assets/images/global-tree_favicon.png',
      favicon: './assets/images/global-tree_favicon.png',
      title: 'Global Tree Admin Dashboard',
      buttonBgColor: '#1e7f43',
      buttonTextColor: '#ffffff',
      buttonDisabledBgColor: 'rgba(26, 27, 31, 0.12)',
      buttonDisabledTextColor: 'rgba(26, 27, 31, 0.38)',
      companyName: 'Global Tree',
      tenantId:'8'
    },
    {
      domain: 'console.gatewayabroad.com',
      // domain: 'localhost',
      loginRoute: '/login',
      defaultRoute: '/dashboard/all-application',
      roleId: '156',
      loginLogo: './assets/images/ga_logo.png',
      dashboardLogo: './assets/images/ga_logo.png',
      dashboardLogoIcon: './assets/images/ga_favicon.png',
      favicon: './assets/images/ga_favicon.png',
      title: 'Gateway Abroad Admin Dashboard',
      buttonBgColor: '#FF0000',
      buttonTextColor: '#ffffff',
      buttonDisabledBgColor: 'rgba(26, 27, 31, 0.12)',
      buttonDisabledTextColor: 'rgba(26, 27, 31, 0.38)',
      companyName: 'Gateway Abroad',
      tenantId:'4'
    },
    {
      domain: 'console.tcyonline.com',
      // domain: 'localhost',
      loginRoute: '/login',
      defaultRoute: '/dashboard/all-application',
      roleId: '165',
      loginLogo: './assets/images/tcy-online.png',
      dashboardLogo: './assets/images/tcy-online.png',
      dashboardLogoIcon: './assets/images/tcy-online_favicon.png',
      favicon: './assets/images/tcy-online_favicon.png',
      title: 'TCYonline Admin Dashboard',
      buttonBgColor: '#143066',
      buttonTextColor: '#ffffff',
      buttonDisabledBgColor: 'rgba(26, 27, 31, 0.12)',
      buttonDisabledTextColor: 'rgba(26, 27, 31, 0.38)',
      companyName: 'TCYonline',
      tenantId:'9'
    },
    {
      domain: 'console.medwayconsultants.com',
      // domain: 'localhost',
      loginRoute: '/login',
      defaultRoute: '/dashboard/all-application',
      roleId: '166',
      loginLogo: './assets/images/medway_logo.png',
      dashboardLogo: './assets/images/medway_logo.png',
      dashboardLogoIcon: './assets/images/medway_favicon.png',
      favicon: './assets/images/medway_favicon.png',
      title: 'Medway Educational Consultant Admin Dashboard',
      buttonBgColor: '#784387',
      buttonTextColor: '#ffffff',
      buttonDisabledBgColor: 'rgba(26, 27, 31, 0.12)',
      buttonDisabledTextColor: 'rgba(26, 27, 31, 0.38)',
      companyName: 'Medway Educational Consultant',
      tenantId:'10'
    },
    {
      domain: 'vidyaportal.crizac.com',
      // domain: 'localhost',
      loginRoute: '/login',
      defaultRoute: '/dashboard/all-application',
      roleId: '167',
      loginLogo: './assets/images/VidyaPortal.png',
      dashboardLogo: './assets/images/VidyaPortal.png',
      dashboardLogoIcon: './assets/images/VidyaPortal_Favicon.png',
      favicon: './assets/images/VidyaPortal_Favicon.png',
      title: 'Vidya Portal Admin Dashboard',
      buttonBgColor: '#0095c7',
      buttonTextColor: '#ffffff',
      buttonDisabledBgColor: 'rgba(26, 27, 31, 0.12)',
      buttonDisabledTextColor: 'rgba(26, 27, 31, 0.38)',
      companyName: 'Vidya Portal',
      tenantId:'11'
    },
    {
      domain: 'console-zelleducation.crizac.com',
      // domain: 'localhost',
      loginRoute: '/login',
      defaultRoute: '/dashboard/all-application',
      roleId: '175',
      loginLogo: './assets/images/zell-education_crizac.png',
      dashboardLogo: './assets/images/zell-education_crizac.png',
      dashboardLogoIcon: './assets/images/zell-education_favicon.png',
      favicon: './assets/images/zell-education_favicon.png',
      title: 'Zell Education Admin Dashboard',
      buttonBgColor: '#6c2875',
      buttonTextColor: '#ffffff',
      buttonDisabledBgColor: 'rgba(26, 27, 31, 0.12)',
      buttonDisabledTextColor: 'rgba(26, 27, 31, 0.38)',
      companyName: 'Zell Education',
      tenantId:'13'
    },
    {
      domain: 'console.foreignadmits.com',
      // domain: 'localhost',
      loginRoute: '/login',
      defaultRoute: '/dashboard/main-dashboard',
      roleId: '177',
      loginLogo: './assets/images/ForeignAdmits.png',
      dashboardLogo: './assets/images/ForeignAdmits_crizac.png',
      dashboardLogoIcon: './assets/images/ForeignAdmits.png',
      favicon: './assets/images/ForeignAdmitsFavicon.png',
      title: 'ForeignAdmits Admin Dashboard',
      buttonBgColor: '#0d95ef',
      buttonTextColor: '#ffffff',
      buttonDisabledBgColor: 'rgba(26, 27, 31, 0.12)',
      buttonDisabledTextColor: 'rgba(26, 27, 31, 0.38)',
      companyName: 'ForeignAdmits',
      tenantId:'14'
    },
    {
      domain: 'inovaeducation.crizac.com',
      // domain: 'localhost',
      loginRoute: '/login',
      defaultRoute: '/dashboard/all-application',
      roleId: '179',
      loginLogo: './assets/images/inovaeducation_crizac.png',
      dashboardLogo: './assets/images/inovaeducation_crizac.png',
      dashboardLogoIcon: './assets/images/inovaeducation_crizac.png',
      favicon: './assets/images/inovaeducation_favicon.png',
      title: 'Inova Education Admin Dashboard',
      buttonBgColor: '#009bd0',
      buttonTextColor: '#ffffff',
      buttonDisabledBgColor: 'rgba(26, 27, 31, 0.12)',
      buttonDisabledTextColor: 'rgba(26, 27, 31, 0.38)',
      companyName: 'Inova Education',
      tenantId:'16'
    },
    {
      domain: 'console-careergyan.crizac.com',
      // domain: 'localhost',
      loginRoute: '/login',
      defaultRoute: '/dashboard/all-leads',
      roleId: '180',
      loginLogo: './assets/images/careergyan_crizac.png',
      dashboardLogo: './assets/images/careergyan_crizac.png',
      dashboardLogoIcon: './assets/images/careergyan_crizac.png',
      favicon: './assets/images/careergyan_favicon.png',
      title: 'CareerGyan Admin Dashboard',
      buttonBgColor: '#243672',
      buttonTextColor: '#ffffff',
      buttonDisabledBgColor: 'rgba(26, 27, 31, 0.12)',
      buttonDisabledTextColor: 'rgba(26, 27, 31, 0.38)',
      companyName: 'CareerGyan',
      tenantId:'17'
    },
  ];

  constructor() { }
  /**
   * Get current domain from window.location.hostname
   * 
   * FOR TESTING: Uncomment one of the return statements below to test specific domains
   * FOR PRODUCTION: Use window.location.hostname (default)
   */
  getCurrentDomain(): string {
    // return 'console.studiesplanet.com';
    // return 'console.globaltree.in';
    // return 'console.gatewayabroad.com';

    // PRODUCTION (use this in production) =====
    return window.location.hostname;  // Auto-detect domain
  }

  /**
   * Get domain configuration based on current hostname
   */
  getCurrentDomainConfig(): DomainConfig {
    const currentDomain = this.getCurrentDomain();

    // Find matching domain config
    const config = this.domainConfigs.find(config =>
      currentDomain.includes(config.domain)
    );

    // Return matched config or default
    return config || this.domainConfigs.find(c => c.domain === 'default')!;
  }

  /**
   * Get login route for current domain
   */
  getLoginRoute(): string {
    return this.getCurrentDomainConfig().loginRoute;
  }

  /**
   * Get default dashboard route for current domain
   */
  getDefaultRoute(): string {
    return this.getCurrentDomainConfig().defaultRoute;
  }

  /**
   * Get login logo for current domain
   */
  getLoginLogo(): string {
    return this.getCurrentDomainConfig().loginLogo || './assets/images/logo.svg';
  }

  /**
   * Get dashboard logo for current domain
   */
  getDashboardLogo(): string {
    return this.getCurrentDomainConfig().dashboardLogo || './assets/images/logo-icon.svg';
  }

  /**
   * Get dashboard logo icon for current domain (for sidebar collapsed state)
   */
  getDashboardLogoIcon(): string {
    return this.getCurrentDomainConfig().dashboardLogoIcon || './assets/images/logo-icon.svg';
  }

  /**
   * Get favicon for current domain
   */
  getFavicon(): string {
    return this.getCurrentDomainConfig().favicon || './assets/images/favicon_crizac.png';
  }

  /**
   * Get title for current domain
   */
  getTitle(): string {
    return this.getCurrentDomainConfig().title || 'Crizac - Dashboard';
  }

  /**
   * Get button background color for current domain
   */
  getButtonBgColor(): string {
    return this.getCurrentDomainConfig().buttonBgColor || '#1976d2';
  }

  /**
   * Get button text color for current domain
   */
  getButtonTextColor(): string {
    return this.getCurrentDomainConfig().buttonTextColor || '#ffffff';
  }

  /**
   * Get button disabled background color for current domain
   */
  getButtonDisabledBgColor(): string {
    return this.getCurrentDomainConfig().buttonDisabledBgColor || 'rgba(26, 27, 31, 0.12)';
  }

  /**
   * Get button disabled text color for current domain
   */
  getButtonDisabledTextColor(): string {
    return this.getCurrentDomainConfig().buttonDisabledTextColor || 'rgba(26, 27, 31, 0.38)';
  }

  /**
   * Get company name for current domain
   */
  getCompanyName(): string {
    return this.getCurrentDomainConfig().companyName || 'Crizac Ltd';
  }

  /**
   * Check if current domain matches a specific domain
   */
  isDomain(domainName: string): boolean {
    return this.getCurrentDomain().includes(domainName);
  }

  /**
   * Get role ID for current domain
   */
  getRoleId(): string | undefined {
    return this.getCurrentDomainConfig().roleId;
  }

  /**
   * Get tenant ID for current domain
   */
  getTenantId(): string {
    return this.getCurrentDomainConfig().tenantId;
  }
}